export const REGULARIZATION_APPROVAL_FLOWS = ["Manager", "HR", "HR_Then_Manager"];

export const INITIAL_FORM_STATE = {
  id: null,

  // Basic Details
  shiftName: "",
  shiftStartTime: "",
  shiftEndTime: "",
  isActive: true,

  // Attendance Thresholds
  strictWorkingHours: "",
  halfDayWorkingHours: "",
  fullDayWorkingHours: "",
  lateArrivalBufferMinutes: "",
  earlyExitBufferMinutes: "",

  // Overtime & Comp Off
  overtimeEnabled: false,
  minimumOvertimeHours: "",
  halfDayOvertimeHours: "",
  fullDayOvertimeHours: "",
  compOffEnabled: false,

  // Attendance Controls
  hrCanMarkAttendance: false,
  hrCanAmendTime: false,
  mandatoryReportBeforeCheckout: false,
  regularizationApprovalFlow: "Manager",
};

export function getInitialFormState() {
  return { ...INITIAL_FORM_STATE };
}